module.exports = __webpack_public_path__ + "img/black_2048.78bff504.png";